// extracted by mini-css-extract-plugin
export default {"category":"Category_category__lmkfr","tags":"Category_tags__ce+Ew"};